/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Primary_LabelInputs */



/**
* | output |
* | --- |
* | "Primary" |
*
* @param {Styles_Primary_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_primary_label = /** @type {((inputs?: Styles_Primary_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Primary_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Primaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Primär")
	if (locale === "it") return /** @type {LocalizedString} */ ("Primario")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начальный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Primario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("基本的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("主要な")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्राथमिक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Primário")
	return /** @type {LocalizedString} */ ("Primary")
});